/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
export enum versionSupport {
  unsupported,
  newest,
  outdated,
}
